import { IEcwidDataStatistics } from '@boxx/gmb-core/lib/contracts/IEcwidData';
import { IPanelAnalyticsPayload } from '@boxx/panel-core';
import { createAction, props } from '@ngrx/store';

export enum PanelActionTypes {
  loadPanelBegin = '[PANEL] Load Panel Begin',
  loadPanelSuccess = '[PANEL] Load Panel Success',
  loadPanelFail = '[PANEL] Load Panel Fail',

  getAnalyticsBegin = '[PANEL] Get Analytics Begin',
  getAnalyticsSuccess = '[PANEL] Get Analytics Success',
  getAnalyticsFail = '[PANEL] Get Analytics Fail',

  getEcwidDataStatusBegin = '[ONBOARDING] Get EcwidData Status Begin',
  getEcwidDataStatusSuccess = '[ONBOARDING] Get EcwidData Status Success',
  getEcwidDataStatusFail = '[ONBOARDING] Get EcwidData Status Fail',

}

// -------------------- PANEL ------------------------
export const loadPanelBeginAction = createAction(
  PanelActionTypes.loadPanelBegin
);

export const loadPanelSuccessAction = createAction(
  PanelActionTypes.loadPanelSuccess,
  props<{ payload: any }>()
);

export const loadPanelFailAction = createAction(
  PanelActionTypes.loadPanelFail,
  props<{ errors: any }>()
);

// -----------------------------------------------
export const getAnalyticsBeginAction = createAction(
  PanelActionTypes.getAnalyticsBegin,
  props<{ filter?: IPanelAnalyticsPayload }>()
);

export const getAnalyticsSuccessAction = createAction(
  PanelActionTypes.getAnalyticsSuccess,
  props<{ payload: any }>()
);

export const getAnalyticsFailAction = createAction(
  PanelActionTypes.getAnalyticsFail,
  props<{ errors: any }>()
);


export const getEcwidDataStatusBeginAction = createAction(
  PanelActionTypes.getEcwidDataStatusBegin
);

export const getEcwidDataStatusSuccessAction = createAction(
  PanelActionTypes.getEcwidDataStatusSuccess,
  props<{ data: IEcwidDataStatistics }>()
);

export const getEcwidDataStatusFailAction = createAction(
  PanelActionTypes.getEcwidDataStatusFail,
  props<{ errors: any }>()
);
